import {
  Box,
  Button,
  FormControl,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import { Formik } from "formik";
import React, { useState } from "react";
import { number, object, string } from "yup";
import { FinalConfirmationRequest } from "../../models/settlement.model";
import { convertToLocalDateTime } from "../../utility/dateUtility";
import DatePickerComponents from "../datePicker/DatePickerComponents";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxWidth: "500px",
  //   maxHeight: "70vh",
  minHeight: "15vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  // overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "4vh",
  // direction: "ltr",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const validation = object().shape({
  sayadNumber: number().min(16, "شماره صیاد باید 16 رقم باشد."),
  cheaqueSeries: number(),
  cheaqueSerial: number(),
  description: string()
    .ensure()
    .max(500, "توضیحات نباید بیش از 500 کاراکتر باشد."),
});

interface Props {
  open: boolean;
  setOpen: (arg: boolean) => void;
  handleSubmition: Function;
  amount: number;
}

const SettelmentConfirmModal = ({
  open,
  setOpen,
  handleSubmition,
  amount,
}: Props) => {
  const [requestDate, setRequestDate] = useState<Date | null | undefined>(
    undefined
  );
  // const [requestDate, setRequestDate] = useState<any>([]);
  const initialValues: FinalConfirmationRequest = {
    sayadNumber: "",
    chequeSeri: "",
    chequeSerial: "",
    chequeDueDate: "",
    description: "",
    key: "",
  };
  function changeValueRequestDate(e: any) {
    setRequestDate(e);
    // setRequestDate(e[0]);
  }

  const handleCloseModal = (values: FinalConfirmationRequest) => {
    setOpen(false);
    values.chequeSerial = "";
    values.chequeSeri = "";
    values.description = "";
    values.sayadNumber = "";
    setRequestDate(null);
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box sx={{ width: "100%", marginBottom: "15px" }}>
          <Typography sx={{ fontSize: "1rem", textAlign: "center" }}>
            آیا از <span style={{ color: "#1565C0" }}>صدور چک</span> با مبلغ{" "}
            <span style={{ color: "#1565C0" }}>
              {amount.toLocaleString("fa")} ریال
            </span>{" "}
            اطمینان دارید؟
          </Typography>
          <Typography
            sx={{ fontSize: ".9rem", textAlign: "center", marginTop: "10px" }}
          >
            جهت دریافت استعلام صحت چک شماره صیادی آن را وارد نمایید
          </Typography>
        </Box>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) =>
            handleSubmition({
              ...values,
              chequeDueDate: convertToLocalDateTime(Number(requestDate)),
            })
          }
          validateOnMount={true}
          validationSchema={validation}
        >
          {({
            handleSubmit,
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
          }) => (
            <form
              onSubmit={handleSubmit}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <Grid container xs={12}>
                <Grid
                  container
                  xs={12}
                  spacing={2}
                  style={{ paddingBottom: "20px" }}
                >
                  <Grid item xs={12} sx={{ paddingLeft: "0px !important" }}>
                    <MaterialTextFieldComponent
                      placeHolder={"شماره صیادی"}
                      label={"شماره صیادی"}
                      required={false}
                      name={"sayadNumber"}
                      id={"sayadNumber"}
                      inputProps={{
                        maxLength: 16,
                      }}
                      value={values.sayadNumber}
                      onChange={handleChange}
                      helperText={touched.sayadNumber ? errors.sayadNumber : ""}
                      error={touched.sayadNumber && Boolean(errors.sayadNumber)}
                      onBlur={handleBlur}
                      onKeyDown={(event) => {
                        if (
                          event.code === "Space" ||
                          (!/^[0-9]$/.test(event.key) &&
                            event.code !== "Backspace")
                        )
                          event.preventDefault();
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  xs={12}
                  spacing={2}
                  style={{ paddingBottom: "20px" }}
                >
                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{ paddingLeft: { xs: "0px !important", md: "10px" } }}
                  >
                    <MaterialTextFieldComponent
                      placeHolder={"سری چک"}
                      label={"سری چک"}
                      required={false}
                      name={"chequeSeri"}
                      id={"chequeSeri"}
                      value={values.chequeSeri}
                      onChange={handleChange}
                      helperText={touched.chequeSeri ? errors.chequeSeri : ""}
                      error={touched.chequeSeri && Boolean(errors.chequeSeri)}
                      onBlur={handleBlur}
                      inputProps={{
                        maxLength: 10,
                      }}
                      onKeyDown={(event) => {
                        if (
                          event.code === "Space" ||
                          (!/^[0-9]$/.test(event.key) &&
                            event.code !== "Backspace")
                        )
                          event.preventDefault();
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                      paddingLeft: "0px !important",
                      paddingRight: { xs: "", md: "10px" },
                    }}
                  >
                    <MaterialTextFieldComponent
                      placeHolder={"سریال چک"}
                      label={"سریال چک"}
                      required={false}
                      name={"chequeSerial"}
                      id={"chequeSerial"}
                      value={values.chequeSerial}
                      onChange={handleChange}
                      inputProps={{
                        maxLength: 10,
                      }}
                      helperText={
                        touched.chequeSerial ? errors.chequeSerial : ""
                      }
                      error={
                        touched.chequeSerial && Boolean(errors.chequeSerial)
                      }
                      onBlur={handleBlur}
                      onKeyDown={(event) => {
                        if (
                          event.code === "Space" ||
                          (!/^[0-9]$/.test(event.key) &&
                            event.code !== "Backspace")
                        )
                          event.preventDefault();
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sx={{ paddingLeft: "0px !important" }}>
                    <FormControl fullWidth className="shadowDatepicker">
                      <DatePickerComponents
                        value={requestDate || null}
                        label={" تاریخ ثبت "}
                        onChange={changeValueRequestDate}
                        range={false}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sx={{ paddingLeft: "0px !important" }}>
                    <MaterialTextFieldComponent
                      placeHolder={"توضیحات"}
                      label={"توضیحات"}
                      name={"description"}
                      id={"description"}
                      value={values.description}
                      onChange={handleChange}
                      helperText={touched.description ? errors.description : ""}
                      error={touched.description && Boolean(errors.description)}
                      onBlur={handleBlur}
                      multiline
                      className={"heightTextField"}
                      sx={{
                        "& .MuiOutlinedInput-root > .MuiInputBase-input ": {
                          fontSize: 13,
                          lineHeight: "2vh !important",
                          height: "6vh !important",
                        },

                        "& .MuiInputBase-root": {
                          height: "14vh !important",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid
                  container
                  justifyContent={"center"}
                  alignItems={"center"}
                  marginBottom={"8px"}
                >
                  <Grid
                    item
                    xs={12}
                    md={6}
                    width={"100%"}
                    sx={{ paddingInline: { xs: "0px", md: "10px" } }}
                  >
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      disabled={!requestDate}
                      className={
                        !requestDate
                          ? "btnForm disabledBtn"
                          : "btnForm SuccessDefault"
                      }
                    >
                      تایید و تسویه حساب
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    width={"100%"}
                    sx={{
                      paddingInline: { xs: "0px", md: "10px" },
                      marginTop: { xs: "8px", md: "0px" },
                    }}
                  >
                    <Button
                      onClick={() => handleCloseModal(values)}
                      fullWidth
                      variant="contained"
                      style={{
                        fontSize: "1rem",
                        color: "#fff",
                        height: "40px",
                        background: "#607D8B",
                      }}
                    >
                      بازگشت
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};

export default SettelmentConfirmModal;
